import Cookies from 'js-cookie'

const TokenUser = 'userDataTime'

export function getUser () {
  if (Cookies.get(TokenUser)) {
    return Cookies.get(TokenUser)
  } else {
    const userString = parseInt(Date.now() / 1000).toString().slice(5) + (Math.floor(Math.random() * 8999) + 1000).toString()
    Cookies.set(TokenUser, userString)
    return userString
  }
}
const TokenKey = 'utoken'

// export function getToken () {
//   return Cookies.get(TokenKey)
// }

// export function setToken (token) {
//   // return Cookies.set(TokenKey, token)
//   return Cookies.set(TokenKey, token, { domain: '.bjadks.com' })
// }

export function removeToken () {
  // return Cookies.remove(TokenKey)
  return Cookies.remove(TokenKey, { domain: '.bjadks.com' })
}



// WEBPACK FOOTER //
// ./src/utils/auth.js